import React from "react";
import { PayInvoiceCheckoutForm } from "./components/StripePayInvoiceCheckoutform";
export const PayInvoiceStripeCardPayment = ({
  setShowAmountError,
  setRefreshPayInvoice,
  setShowPayInvoiceDialog,
  funcToCall,
  setFucToCallOnPay,
  amount,
  cpData,
  selectedInvoices,
}) => {
  return (
    <PayInvoiceCheckoutForm
      setShowAmountError={setShowAmountError}
      cpData={cpData}
      setRefreshPayInvoice={setRefreshPayInvoice}
      setShowPayInvoiceDialog={setShowPayInvoiceDialog}
      funcToCall={funcToCall}
      setFucToCallOnPay={setFucToCallOnPay}
      selectedInvoices={selectedInvoices}
      amount={amount}
    />
  );
};
